import React, { useEffect, useState } from "react";
import Keycloak from "keycloak-js";
import flaz_logo_login from "../../assets/image/flaz_logo_login.svg";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import AuthFunctions from "../../components/helpers/authservice";
import axios from "axios";
import { authConfiguration } from "./common";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export const KeyCloackLoginClient = ({ appName }) => {
  const [userName, setUserName] = useState("");
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");

  const handleEmailChange = (event) => {
    setUserName(event.target.value);
    if (isError) {
      setError("");
      setIsError(false);
    }
  };

  const navigate = () => {
    const redirect = process.env.REACT_APP_ONBOARDING_URL;
    window.location.href = redirect;
  };
  const currentENV = process.env.REACT_APP_ENV;

  if (currentENV == "PROD") {
    return <AuthFunctions>{({ handleLogin }) => <></>}</AuthFunctions>;
  }

  return (
    <AuthFunctions>
      {({ handleLogin }) => (
        <>
          <div className="login-modal">
            <div className="login-modal-content">
              <img src={flaz_logo_login} alt="Logo" className="logo" />
              <h2 className="app-name my-2">{appName}</h2>
              <div className="mb-3 emailWidth">
                <TextField
                  fullWidth
                  id="emailfield"
                  className="text-field"
                  value={userName}
                  onChange={handleEmailChange}
                  error={isError}
                  required
                  helperText={error}
                  placeholder="Email"
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      if (userName.trim()) {
                        handleLogin(userName);
                      } else {
                        setError("Please fill the field");
                        setIsError(true);
                      }
                  }}
                  sx={{
                    borderRadius: "0px",
                  }}
                />
              </div>
              <button
                className="login-button"
                onClick={() => {
                  if (userName.trim()) {
                    handleLogin(userName);
                  } else {
                    setError("Please fill the field.");
                    setIsError(true);
                  }
                }}
              >
                Login
              </button>
              <span className="signuplink" onClick={navigate}>
                Sign up
              </span>
            </div>
          </div>
          <div></div>
        </>
      )}
    </AuthFunctions>
  );
};
